import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'rod-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public newDate = new Date();
  public theYear = this.newDate.getFullYear();
  @Input() fullWidth: boolean;
  @Output() public routeChange: EventEmitter<any> = new EventEmitter();

  constructor(private _router: Router, private _activeRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  fireRouteChange(e) {
    this.routeChange.emit({ url: this._router.url });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts